import { ArrowLeftOutlined, DownOutlined } from "@ant-design/icons";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import {
  Add,
  Delete,
  Edit,
} from '@mui/icons-material';
import { Button as AntButton, Card, Col, Input, Row, Tooltip } from "antd";
import Loading from "components/Loading";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { isEmpty } from "lodash";
import { handleEditRubric, handleGetRubric } from "store/rubric/thunks";
import { useCurrentUser } from "store/users/selectors";
import { useDispatch } from "react-redux";
import ModalMenu from "components/Modals";

const BORDERCOLOR = [
  "rgb(200,109,152)",
  "rgb(146,158,227)",
  "rgb(80,233,200)",
  "rgb(238,206,151)",
];

const RubricCompoment = ({ states = {}, funcObject = {} , from='' }) => {
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  const location = useLocation();
  							  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(false);
  const [openPreviewContent, setOpenPreviewContent] = useState(false);
  const { updateStates, deleteHandler } = funcObject || null;
  const { rubricData, loader, selectedRubric, filteredResult } = states || null;
  const [hideUnhideRubricId, setHideUnhideRubricId] = useState({id: "", type:""});
  const [openArchivedConfirmation, setOpenArchivedConfirmation] = useState(false);
  const [loaderForHide,setLoaderHide] = useState(false);
  const is_placement = from =="placement"

  const openModalHandler = (open, value) => {
    updateStates("rubricForm", {
      open,
      form: value,
    });
  };

  const onSearch = (event) => {
    if (
      event?.target?.value?.trim() &&
      event?.target?.value?.trim().length >= 1
    ) {
      let search = event.target.value;
      const filteredResult = rubricData?.filter((data) =>
        data?.title?.toLowerCase().includes(search.toLowerCase())
      );
      updateStates("filteredResult", filteredResult);
    } else {
      updateStates("filteredResult", rubricData);
    }
  };

  const openArchivedConfirmationModal = (id,type) => {
    setOpenArchivedConfirmation(true);
    setHideUnhideRubricId({id, type});
  } 

  const handlerHideRubric = async () => {
    setLoaderHide(true);
    const rubric = filteredResult?.find(element => element?.id === hideUnhideRubricId?.id) || {};
    const payload = {...rubric, is_hide: !rubric?.is_hide}
    await dispatch(handleEditRubric(payload));
    await dispatch(handleGetRubric(currentUser?.id));
    setLoaderHide(false);
  }
  return (
    <>
      <OpenPreviewRubric
        open={openPreviewContent}
        close={() => {
          setOpenPreviewContent(false);
          updateStates("selectedRubric", {});
        }}
        rubrics_meta={selectedRubric?.rubrics_meta}
        mainTitle={selectedRubric?.title}
      />
        <ModalMenu
        type="closeConfirmationModal"
        open={openArchivedConfirmation}
        is_placement={is_placement}
        close={() => {
          setOpenArchivedConfirmation(false);
          setHideUnhideRubricId({id: "",type: ""});
        }}
        messageTitle={`Are you sure you want to ${hideUnhideRubricId?.type} this rubric?`}
        actionOnOk = {() => handlerHideRubric()}
        isLoading={loaderForHide}
      />
      {!openPreviewContent && (
        <>
         {!is_placement&& <AntButton
            type="link"
            primary
            style={{ paddingLeft: 0, fontSize: 17, marginBottom: 20 }}
            onClick={() => navigate(-1)}
          >
            <ArrowLeftOutlined />
            Back
          </AntButton>}

          <RubricContainer>
            <RubricButton
              onClick={() => openModalHandler(true, "createRubricModal")}
            >
              <Add /> Create Rubric
            </RubricButton>

            <FilterContainer className="FilterHeading">
              <Card type="inner" title="Filters">
                <Row>
                  <Col xs={24} lg={24} md={24} className="ColCardPadding">
                    <Card style={{ width: "100%" }}>
                      <Input
                        placeholder="Search by name"
                        bordered={false}
                        style={{ height: "32px" }}
                        onChange={onSearch}
                      />
                    </Card>
                  </Col>
                </Row>
              </Card>
            </FilterContainer>

            <Table
              stickyHeader
              aria-label="sticky table"
              style={{
                width: "100%",
                textAlign: "center",
                backgroundColor: "#fff",
                marginTop: 20,
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      textAlign: "left",
                      fontSize: 16,
                      fontWeight: "600",
                    }}
                  >
                    Title
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "left",
                      fontSize: 16,
                      fontWeight: "600",
                    }}
                  >
                    Max Point
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "left",
                      fontSize: 16,
                      fontWeight: "600",
                    }}
                  >
                    Criteria
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "left",
                      fontSize: 16,
                      fontWeight: "600",
                    }}
                  >
                    Points
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "left",
                      fontSize: 16,
                      fontWeight: "600",
                    }}
                  >
                    Edit
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "left",
                      fontSize: 16,
                      fontWeight: "600",
                    }}
                  >
                    Delete
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "left",
                      fontSize: 16,
                      fontWeight: "600",
                    }}
                  >
                    Preview
                  </TableCell>
                 {!is_placement&& <TableCell
                    style={{
                      textAlign: "left",
                      fontSize: 16,
                      fontWeight: "600",
                    }}
                  >
                    Assigned
                  </TableCell>}
                {!is_placement&& <TableCell
                    style={{
                      textAlign: "left",
                      fontSize: 16,
                      fontWeight: "600",
                    }}
                  >
                     Show/Hide
                  </TableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {isEmpty(filteredResult) && (
                  <TableRow key={"0"} style={{ border: 0 }}>
                    <TableCell colSpan={7} style={{ textAlign: "center" }}>
                      No results
                    </TableCell>
                  </TableRow>
                )}
                {!isEmpty(filteredResult) &&
                  filteredResult?.map((element, index) => {
                    const points = element?.rubrics_meta?.reduce(
                      (acc, d) => acc + (d?.points?.length || 0),
                      0
                    );
                    const isAssigned =
                      element?.total_assigned &&
                      Number(element?.total_assigned) > 0;
                    return (
                      <TableRow
                        key={index}
                        style={{
                          "&:lastChild td, &:lastChild th": { border: 0 },
                        }}
                        onClick={() => setSelectedIndex(index)}
                      >
                        <TableCell
                          style={{ textAlign: "left", cursor: "pointer" }}
                          onClick={() => {}}
                        >
                          <Tooltip placement="top" title={element?.title}>
                            <span className="text-wrap">
                              {element?.title?.length > 40
                                ? element?.title?.slice(0, 40) + "..."
                                : element?.title || ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            color: BORDERCOLOR[0],
                            cursor: "pointer",
                          }}
                          onClick={() => {}}
                        >
                          <span className="text-wrap">
                            {element?.max_point}
                          </span>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            color: BORDERCOLOR[0],
                            cursor: "pointer",
                            maxWidth: 380,
                          }}
                          onClick={() => {}}
                        >
                          <span className="text-wrap">
                            {element.rubrics_meta?.length || 0}
                          </span>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            color: BORDERCOLOR[0],
                            cursor: "pointer",
                            maxWidth: 380,
                          }}
                          onClick={() => {}}
                        >
                          <span className="text-wrap">
                            {(points && points) || 0}
                          </span>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            color: "black",
                            cursor: "pointer",
                            maxWidth: 380,
                          }}
                          onClick={async () => {
                            await updateStates("selectedRubric", element);
                            openModalHandler(true, "createRubricModal");
                          }}
                        >
                          <Edit />
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            color: "red",
                            cursor: "pointer",
                            maxWidth: 380,
                          }}
                          onClick={async () => {
                            await updateStates("selectedRubric", element);
                            openModalHandler(true, "closeConfirmationModal");
                          }}
                        >
                          <StyledButton
                            style={{
                              cursor:
                                (loader && selectedIndex === index) ||
                                (element?.total_assigned &&
                                  Number(element?.total_assigned) > 0 &&
                                  "default"),
                              opacity:
                                (loader && selectedIndex === index) ||
                                (element?.total_assigned &&
                                  Number(element?.total_assigned) > 0 &&
                                  "0.4"),
                            }}
                            disabled={
                              (loader && selectedIndex === index) ||
                              (element?.total_assigned &&
                              Number(element?.total_assigned) > 0
                                ? true
                                : false)
                            }
                          >
                            {loader && selectedIndex === index && (
                              <Loading size={20} />
                            )}
                            <Delete />
                          </StyledButton>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            color: BORDERCOLOR[0],
                            cursor: "pointer",
                          }}
                          onClick={async () => {
                            await updateStates("selectedRubric", element);
                            setOpenPreviewContent(true);
                          }}
                        >
                          <span className="text-wrap">Preview</span>
                        </TableCell>
                       {!is_placement&& <TableCell
                          style={{
                            textAlign: "left",
                            color: BORDERCOLOR[0],
                            cursor: "pointer",
                          }}
                          onClick={async () => {}}
                        >
                          <span
                            className={`${
                              isAssigned ? "text-green-10" : "text-red-10"
                            }`}
                          >
                            {isAssigned ? "Assigned" : "Not Assigned"}
                          </span>
                        </TableCell>}

                        {!is_placement&&  <TableCell
                          style={{
                            textAlign: "left",
                            color: BORDERCOLOR[0],
                            cursor: "pointer",
                          }}
                          onClick={async () => {
                            openArchivedConfirmationModal(element?.id, element?.is_hide ? "show" : "hide");
                          }}
                        >
                          <button
                            className={`${
                              element?.is_hide ? "show-rubric-button" : "hide-rubric-button"
                            }`}
                          >
                            {element?.is_hide ? "Show Rubric" : "Hide Rubric"}
                          </button>
                        </TableCell>}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </RubricContainer>
        </>
      )}
    </>
  );
};

const OpenPreviewRubric = ({
  open,
  close,
  rubrics_meta = [],
  mainTitle = "",
}) => {
  const maxPoint = rubrics_meta?.reduce(
    (sum, criterion) =>
      sum + Math.max(...criterion.points.map((point) => point.pointText)),
    0
  );

  const [rubricOpen, setRubricOpen] = useState(
    rubrics_meta.reduce((acc, _, index) => {
      acc[index] = false;
      return acc;
    }, {})
  );

  const toggleRubricOpen = (index) => {
    setRubricOpen((prevOpen) => ({
      ...prevOpen,
      [index]: !prevOpen[index],
    }));
  };
  const resetRubricOpen = () => {
    const resetState = rubrics_meta.reduce((acc, _, index) => {
      acc[index] = false;
      return acc;
    }, {});
    setRubricOpen(resetState);
  };
  return (
    <>
      {open && (
        <>
          <AntButton
            type="link"
            primary
            style={{ paddingLeft: 0, fontSize: 17, marginBottom: 20 }}
            onClick={() =>{
               resetRubricOpen();
               close()}}
          >
            <ArrowLeftOutlined />
            Back to Rubric
          </AntButton>
          <div className="rubric-container">
            <div className="rubricHeader">
              <h2>{mainTitle}</h2>
              <div>
                <span className="score">/{maxPoint}</span>
              </div>
            </div>

            {rubrics_meta.map((criterion, index) => (
              <div key={index} className="rubric-section">
                <div className="allClrSection">
                  <h4>{criterion.criterionTitle}</h4>
                  <div className="assignmentPoints">
                    <p>{`/${Math.max(
                      ...criterion.points.map((point) => point.pointText)
                    )}`}</p>
                    <div
                      className="rubricContainer"
                      onClick={() => toggleRubricOpen(index)}
                    >
                      <div
                        style={{
                          transition: "transform 0.4s ease-in-out",
                          transform: rubricOpen[index]
                            ? "rotate(-180deg)"
                            : "rotate(0deg)",
                        }}
                      >
                        <DownOutlined
                          style={{ color: "rgb(14 70 183 / 87%)" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {!rubricOpen[index] ? (
                  <div>
                    <p>{criterion.criterionDescription}</p>
                    <div className="rubric-items">
                      {criterion.points.map((point, pointIndex) => (
                        <div
                          key={pointIndex}
                          className={`rubric-item cursor-default `}
                        >
                          <div className="allRubricPoint">
                            <div className="rubricPoint">
                              {point.title}
                              <span>{point.pointText} pts</span>
                            </div>
                            <p style={{ fontSize: "13px" }}>
                              {point.description}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="rubric-items">
                    {criterion.points.map((point, pointIndex) => (
                      <div
                        key={pointIndex}
                        style={{ width: "fit-content" }}
                        className={`rubricNewSection`}
                      >
                        <label>{point.pointText} pts</label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default RubricCompoment;

const FilterContainer = styled.span`
  font-size: 17px;
  font-weight: 500;
  cursor: pointer;
`;
const StyledButton = styled.button`
  background: none;
  border: none;
  outline: none;
  padding: none;
  display: flex;
  align-items: center;
  gap: 10px;
`;

// const AssignmentIcon = styled.div`
//   background: #5f6368;
//   border-radius: 17px;
//   padding: 8px;
//   display: grid;
//   place-items: center;
// `;

// const RubricButtonShow = styled.div`
//   background-color: #fff;
//   margin-bottom: 16px;
//   align-self: start;
//   border: 1px solid #dadce0;
//   color: #3c4043;
//   fill: #3c4043;
//   padding-inline: 12px;
//   padding-top: 5px;
//   padding-bottom: 3px;
//   min-width: 173px;
//   border-radius: 16px;
//   display: inline-block;
//   font-family: "Google Sans", Roboto, Arial, sans-serif;
//   font-size: 14px;
//   font-weight: 500;
//   letter-spacing: 0.25px;
//   text-align: center;
//   transition: background 0.2s 0.1s;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
// `;

// const RubricListDetailContainer = styled.div`
//   color: rgb(26, 115, 232);
//   font-size: 0.875rem;
//   letter-spacing: 0.0107142857em;
//   font-weight: 500;
//   text-transform: none;
// `;

// const RubricParentContainer = styled.div`
//   display: flex;
//   align-items: center;
//   flex-direction: row;
//   width: 100%;
//   border-bottom: 0.0625rem solid #e0e0e0;
//   box-sizing: border-box;

//   position: relative;
//   z-index: 0;
//   cursor-pointer;
//   position:relative;
// `;

// const RubricListContainer = styled.div`
//   display: flex;
//   align-items: center;
//   width: 100%;
//   justify-content: space-between;
//   height: 3.75rem;
//   position: relative;
//   z-index: 0;
//   cursor-pointer;
//   position:relative;
// `;

const RubricContainer = styled.div`
  margin: 0 auto;
  // max-width: 47.5rem;
  ${'' /* padding: 1.5rem 1.5rem; */}
`;

const RubricButton = styled.button`
  background: rgb(26, 115, 232);
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  outline: none;
  border: none;
  box-shadow: 0 1px 2px 0 rgba(32, 33, 36, 0.3),
    0 2px 6px 2px rgba(32, 33, 36, 0.15);
  height: 3rem;
  margin: 0;
  padding: 0 1.25rem 0 1rem;
  border-radius: 5px;
  margin-bottom: 20px;
`;
